import { render } from "./DetailsHeader.vue?vue&type=template&id=d2ca96c4&ts=true"
import script from "./DetailsHeader.ts?vue&type=script&lang=ts"
export * from "./DetailsHeader.ts?vue&type=script&lang=ts"

import "./DetailsHeader.css?vue&type=style&index=0&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__